// extracted by mini-css-extract-plugin
module.exports = {"mainContent":"style_mainContent__1WjKk"};